import Image from 'next/image'
import {
  BlogCardContainer,
  BlogDescription,
  CardDateCategoryAndShareContainer,
  Divider,
  ImageContainer,
  PostTitle,
} from './styled'
import { formatDate } from '../formatDate'

import Link from 'next/link'
import ShareSocialButtons from '../ShareSocialButtons'
import { Typography } from '@mui/material'

const BlogCard = ({ post, featured }: { post: IPost; featured: boolean }) => {
  return (
    <Link href={`/blog/${post.slug}`} passHref>
      <BlogCardContainer>
        <ImageContainer featured={featured}>
          <Image
            src={post?.thumbnail?.fullSize || '/assets/blog/fallback_image.svg'}
            alt={post.title}
            layout="fill"
            objectFit="cover"
            priority
            loader={({ src, width }) => `${src}?w=${width}`}
            blurDataURL={post?.thumbnail?.fullSize || '/assets/blog/fallback_image.svg'}
          />
        </ImageContainer>
        <CardDateCategoryAndShareContainer>
          {post?.category && (
            <Typography variant="overline" color="primary.500">
              {post.category.title}
            </Typography>
          )}
          {post?.category && <Divider />}
          <Typography variant="overline" color="surface.400">
            {formatDate(post.created)}
          </Typography>
          {featured && (
            <div style={{ marginLeft: 'auto' }}>
              <ShareSocialButtons postSlug={post.slug} cardComponent />
            </div>
          )}
        </CardDateCategoryAndShareContainer>
        <PostTitle featured={featured}>{post.title}</PostTitle>
        <BlogDescription>{post.description}</BlogDescription>
        {!featured && (
          <div style={{ marginTop: '20px' }}>
            <ShareSocialButtons postSlug={post.slug} cardComponent />
          </div>
        )}
      </BlogCardContainer>
    </Link>
  )
}

export default BlogCard
